import { createBrowserClient } from '@supabase/ssr'
import type { SupabaseClient } from '@supabase/supabase-js'
import {
  getRegionBasedSupabaseAnonKey,
  getRegionBasedSupabaseUrl
} from '../urls'
import { getUserRegionFromLocalStorage } from '@/lib/auth-service'

let supabaseInstance: SupabaseClient | null = null

export function createClient() {
  if (!supabaseInstance || supabaseInstance.auth.getSession() === null) {
    const region = getUserRegionFromLocalStorage()
    if (!region) {
      throw new Error('Region not found! This error should not happen.')
    }

    const supabaseUrl = getRegionBasedSupabaseUrl(region)
    const supabaseAnonKey = getRegionBasedSupabaseAnonKey(region)

    console.log('Supabase url', {
      supabaseUrl,
      region
    })

    supabaseInstance = createBrowserClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
      }
    })
  }
  return supabaseInstance
}
